// Spec s5.2: append-only, ordered, never truncated, never summarized, never
// windowed, never persisted. A 60-minute call is a few thousand tokens; there
// is nothing here worth compressing.

import type { TranscriptSegment } from './Transcriber';

export class TranscriptBuffer {
  private segments: TranscriptSegment[] = [];
  private revision = 0;

  /** Increments on every append. The extraction loop uses it to skip no-op passes. */
  get version(): number {
    return this.revision;
  }

  get length(): number {
    return this.segments.length;
  }

  append(segment: TranscriptSegment): void {
    if (!segment.text.trim()) return;
    this.segments.push(segment);
    this.revision += 1;
  }

  all(): readonly TranscriptSegment[] {
    return this.segments;
  }

  /** The whole buffer as one string, in timestamp order. */
  render(): string {
    return [...this.segments]
      .sort((a, b) => a.startMs - b.startMs)
      .map((segment) => segment.text.trim())
      .join(' ');
  }

  clear(): void {
    this.segments = [];
    this.revision = 0;
  }
}
